import { z } from 'zod'

export const agreementTemplateSearchSchema = z.object({
  search: z.string().max(200).optional().catch(undefined),
  languageIds: z.array(z.string()).optional().catch(undefined),
  status: z.enum(['all', 'active', 'inactive']).catch('all'),
  use: z.enum(['all', 'used', 'unused']).catch('all'),
  page: z.coerce.number().int().min(1).catch(1),
  pageSize: z.coerce
    .number()
    .pipe(z.union([z.literal(10), z.literal(25), z.literal(50)]))
    .catch(10),
  sortBy: z
    .enum([
      'title',
      'description',
      'nrPrefix',
      'language',
      'active',
      'hasFile',
      'internshipCount',
      'activeInternshipCount',
      'internCount',
      'activeInternCount',
    ])
    .catch('title'),
  direction: z.enum(['asc', 'desc']).catch('asc'),
})

export type AgreementTemplateSearch = z.infer<typeof agreementTemplateSearchSchema>

export const defaultAgreementTemplateSearch: AgreementTemplateSearch = {
  status: 'all',
  use: 'all',
  page: 1,
  pageSize: 10,
  sortBy: 'title',
  direction: 'asc',
}
